import styles from "./menuLink.module.css";

const ClassLink = () => {
  return (
    <div className={styles.classLink}>
      <h4 style={{ margin: "0", fontWeight: "800" }}>Class 7A</h4>
      <div className={styles.spacer} />
    </div>
  );
};

export default ClassLink;
